import {
  ComponentSize,
  ComponentVariant,
} from 'src/modules/shared/types/component.type';

export const tableCellText = 'font-normal text-xs';
export const tableHeaderText = 'font-medium text-sm';

export const tableCellPadding: Record<ComponentSize, string> = {
  '2xs': '!py-1 !px-2',
  xs: '!py-1.5 !px-3',
  sm: '!py-2 !px-4',
  md: '!py-3 !px-6',
  lg: '!py-4 !px-6',
};

export const tableHeaderPadding: Record<ComponentSize, string> = {
  '2xs': '!py-2.5 !px-2',
  xs: '!py-3 !px-3',
  sm: '!py-3.5 !px-4',
  md: '!py-4.5 !px-6',
  lg: '!py-6 !px-6',
};

// Variant-specific styles
export const tableVariantClasses: Record<
  ComponentVariant,
  {
    row: string;
    rowHover: string;
    rowSelected: string;
    text: string;
    hoverText: string;
  }
> = {
  primary: {
    row: 'bg-primary-50',
    rowHover: 'hover:bg-primary-50',
    rowSelected: 'bg-primary-100',
    text: 'text-secondary-600',
    hoverText: 'hover:text-primary-500',
  },
  secondary: {
    row: 'bg-secondary-50',
    rowHover: 'hover:bg-secondary-50',
    rowSelected: 'bg-secondary-100',
    text: 'text-secondary-600',
    hoverText: 'hover:text-secondary-500',
  },
  neutral: {
    row: 'bg-white',
    rowHover: 'hover:bg-neutral-50',
    rowSelected: 'bg-neutral-100',
    text: 'text-neutral-600',
    hoverText: 'hover:text-neutral-500',
  },
  danger: {
    row: 'bg-danger-50',
    rowHover: 'hover:bg-danger-50',
    rowSelected: 'bg-danger-100',
    text: 'text-danger-600',
    hoverText: 'hover:text-danger-500',
  },
  warning: {
    row: 'bg-warning-50',
    rowHover: 'hover:bg-warning-50',
    rowSelected: 'bg-warning-100',
    text: 'text-warning-600',
    hoverText: 'hover:text-warning-500',
  },
  success: {
    row: 'bg-success-50',
    rowHover: 'hover:bg-success-50',
    rowSelected: 'bg-success-100',
    text: 'text-success-600',
    hoverText: 'hover:text-success-500',
  },
  info: {
    row: 'bg-info-50',
    rowHover: 'hover:bg-info-50',
    rowSelected: 'bg-info-100',
    text: 'text-info-600',
    hoverText: 'hover:text-info-500',
  },
  whatsapp: {
    row: 'bg-whatsapp-50',
    rowHover: 'hover:bg-whatsapp-50',
    rowSelected: 'bg-whatsapp-100',
    text: 'text-whatsapp-600',
    hoverText: 'hover:text-whatsapp-500',
  },
  call: {
    row: 'bg-call-50',
    rowHover: 'hover:bg-call-50',
    rowSelected: 'bg-call-100',
    text: 'text-call-600',
    hoverText: 'hover:text-call-500',
  },
  email: {
    row: 'bg-email-50',
    rowHover: 'hover:bg-email-50',
    rowSelected: 'bg-email-100',
    text: 'text-email-600',
    hoverText: 'hover:text-email-500',
  },
};

export const tableContainerClasses =
  'flex-1 overflow-y-auto rounded-lg mx-3.5 p-2.5 w-full !p-0 !m-0 h-full overflow-auto scroll-shadows relative z-[1]';
export const tableHeaderRowBase = '!border-b-2 !border-secondary-400';
export const tableRowTransition = 'transition-colors duration-50';

export const stickyHeaderBase = 'sticky top-0 !bg-inherit';
export const stickyHeaderWithZIndex = 'sticky top-0 !bg-inherit !z-[40]';
export const stickyColumnBase = 'sticky z-[30]';
